<template>
  <v-card outlined class="dashboard-bus-card rounded-xl pa-5" elevation="0">
    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-subtitle-1 font-weight-bold text-uppercase text-grey-darken-3">Tình trạng xe tuyến</h3>
      <div class="text-body-2 grey--text d-flex align-center">
        Cập nhật lúc {{ lastUpdated }}
        <v-btn icon small class="ml-1" @click="fetchData" :loading="loading">
          <v-icon small color="primary">mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>

    <v-row v-if="!loading">
      <v-col
        cols="12"
        md="6"
        v-for="(session, index) in sessionConfigs"
        :key="session.key"
        :class="{
          'pr-md-6': index === 0,
          'pl-md-6': index === 1,
          'border-right-divider': index === 0,
        }"
      >
        <bus-session-card :title="session.title" :stats="stats[session.key]" />
      </v-col>
    </v-row>

    <div v-else class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import { BusCheckin } from '@/plugins/api'
import moment from 'moment'
import BusSessionCard from './BusSessionCard.vue'

export default {
  name: 'DashboardBusStatus',
  components: {
    BusSessionCard,
  },
  data() {
    return {
      loading: false,
      lastUpdated: '',
      sessionConfigs: [
        { key: 'morning', title: 'Buổi sáng - Chiều đi' },
        { key: 'afternoon', title: 'Buổi chiều - Chiều về' },
      ],
      stats: {
        morning: { total: 0, completed: 0, running: 0, pending: 0 },
        afternoon: { total: 0, completed: 0, running: 0, pending: 0 },
      },
    }
  },
  async created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await BusCheckin.getDashboadBus()
        const data = response.data || response
        if (data) {
          this.stats = data
        }
        this.lastUpdated = moment().format('HH:mm, DD/MM/YYYY')
      } catch (error) {
        console.error('Lỗi khi tải dữ liệu xe tuyến:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.dashboard-bus-card {
  border-color: #dde3f0 !important;
  box-shadow: 0 2px 12px rgba(25, 50, 120, 0.08) !important;
}

@media (min-width: 960px) {
  .border-right-divider {
    border-right: 1px solid #dee3ef;
  }
}

.text-grey-darken-3 {
  color: #424242;
}
</style>
